(function () {
  var boundsByPath = {};
  var pendingByPath = {};
  var RANGE_SELECTOR = 'xo-range[xo-component-name="range-price"]';

  function collectionPath() {
    var match = window.location.pathname.match(/^\/collections\/[^/]+/);
    return match ? match[0] : null;
  }

  function roundMoney(value) {
    return Math.round(value * 100) / 100;
  }

  function nearly(a, b) {
    return Math.abs(Number(a) - Number(b)) < 0.05;
  }

  function loadBounds(path) {
    var page = 1;
    var min = Infinity;
    var max = -Infinity;
    var found = false;

    function next() {
      return fetch(path + '/products.json?limit=250&page=' + page, {
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('price range');
          return response.json();
        })
        .then(function (data) {
          var products = data && data.products ? data.products : [];
          products.forEach(function (product) {
            (product.variants || []).forEach(function (variant) {
              var price = parseFloat(variant.price);
              if (!isFinite(price)) return;
              found = true;
              if (price < min) min = price;
              if (price > max) max = price;
            });
          });
          if (products.length === 250 && page < 20) {
            page += 1;
            return next();
          }
          if (!found || min > max) return null;
          return { min: roundMoney(min), max: roundMoney(max) };
        });
    }

    return next();
  }

  function ensureBounds(path) {
    if (boundsByPath[path]) return Promise.resolve(boundsByPath[path]);
    if (pendingByPath[path]) return pendingByPath[path];
    pendingByPath[path] = loadBounds(path)
      .then(function (bounds) {
        if (bounds) boundsByPath[path] = bounds;
        delete pendingByPath[path];
        return bounds;
      })
      .catch(function () {
        delete pendingByPath[path];
        return null;
      });
    return pendingByPath[path];
  }

  function hasChosenPrice() {
    var params = new URLSearchParams(window.location.search);
    return params.has('filter.v.price.gte') || params.has('filter.v.price.lte');
  }

  function isReady(el) {
    var inputs = el.querySelectorAll('input[type="range"]');
    if (inputs.length < 2 || !Array.isArray(el.value) || el.value.length !== 2) return false;
    var attr = el.getAttribute('xo-value');
    if (!attr) return false;
    var parts = attr.replace(/[\[\]]/g, '').split(',');
    if (parts.length !== 2) return false;
    return nearly(el.value[0], parts[0]) && nearly(el.value[1], parts[1]);
  }

  function syncStoreBounds(bounds) {
    if (!window.xoStore || typeof window.xoStore.set !== 'function') return;
    try {
      window.xoStore.set('xo-filters', function (prevState) {
        return Object.assign({}, prevState, {
          priceMin: bounds.min,
          priceMax: bounds.max
        });
      })('tc-price-range/setPriceMinMax');
    } catch (e) {
      /* ignore store sync failures */
    }
  }

  function applyToRange(el, bounds) {
    if (!isReady(el)) return false;
    var inputs = el.querySelectorAll('input[type="range"]');

    var oldMin = Number(el.getAttribute('xo-min'));
    var oldMax = Number(el.getAttribute('xo-max'));
    var current = el.value;
    var fullSpan =
      Array.isArray(current) &&
      current.length === 2 &&
      (nearly(current[0], 0) || nearly(current[0], oldMin) || nearly(current[0], el.min)) &&
      (nearly(current[1], oldMax) || nearly(current[1], el.max));

    el.setAttribute('xo-min', String(bounds.min));
    el.setAttribute('xo-max', String(bounds.max));
    el.min = bounds.min;
    el.max = bounds.max;
    inputs.forEach(function (input) {
      input.min = String(bounds.min);
      input.max = String(bounds.max);
    });

    if (!hasChosenPrice() && fullSpan) {
      var nextAttr = '[' + bounds.min + ', ' + bounds.max + ']';
      el.initialized = false;
      if (el.getAttribute('xo-value') !== nextAttr) {
        el.value = [bounds.min, bounds.max];
      } else if (typeof el.handler === 'function') {
        el.handler([bounds.min, bounds.max]);
      }
    } else if (typeof el.handler === 'function') {
      el.handler(el.value);
    }

    return true;
  }

  function applyBounds(bounds, attempt) {
    var ranges = document.querySelectorAll(RANGE_SELECTOR);
    if (!ranges.length || !bounds) return;

    var pending = false;
    ranges.forEach(function (el) {
      if (!applyToRange(el, bounds)) pending = true;
    });

    if (!pending) {
      syncStoreBounds(bounds);
    }

    if (pending && attempt < 20) {
      window.setTimeout(function () {
        applyBounds(bounds, attempt + 1);
      }, 50);
    }
  }

  function refresh() {
    var path = collectionPath();
    if (!path || !document.querySelector(RANGE_SELECTOR)) return;
    ensureBounds(path).then(function (bounds) {
      if (bounds) applyBounds(bounds, 0);
    });
  }

  function bindFiltersDone() {
    if (window.xoFilters && typeof window.xoFilters.on === 'function') {
      window.xoFilters.on('done', refresh);
      return true;
    }
    return false;
  }

  function start() {
    refresh();
    if (bindFiltersDone()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (bindFiltersDone() || tries > 40) window.clearInterval(timer);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
